module.exports = __webpack_public_path__ + "82a04efc884d5a34bf9de0a801affde7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/edit.png
// module id = 476
// module chunks = 0